import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { limpiarProductoConfiguracion, obtenerProductoConfiguracion, editarProductoConfiguracion } from '../../../actions/configuracion';

const DetallesProducto = ({ producto, reestablecerProducto }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.productos);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [productoData, setProductoData] = useState({
        id: null,
        nombre: null, 
        descripcion: null
    });

    /* Editar producto */
    const handleInputChange = ({ target }) => {
        setProductoData({
            ...productoData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(productoData.nombre){
            await setStatusProcesar(true);
            await dispatch(editarProductoConfiguracion(productoData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setProductoData({
                id: null,
                nombre: null, 
                descripcion: null
            });
            setEditarModal(false);
            reestablecerProducto(null);
        }
    }

    useEffect(() => {
        dispatch(limpiarProductoConfiguracion());
    }, []);

    useEffect(() => {
        if(producto){
            setEditarModal(true);
            
            dispatch(obtenerProductoConfiguracion(producto?._id));

            setProductoData({
                ...productoData,
                id: producto?._id
            });
        }
    }, [producto]);

    useEffect(() => {
        if(detalles){
            setProductoData({
                ...productoData,
                id: detalles?._id, 
                nombre: detalles?.nombre, 
                descripcion: detalles?.descripcion
            });
        }
    }, [detalles]);

    return (
        <Modal show={editarModal} backdrop="static" size="md" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar producto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={productoData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <textarea className="form-control textareCampo" placeholder="Descripción" id="descripcion" name="descripcion" value={productoData.descripcion} onChange={e => handleInputChange(e)}></textarea>
                                <label htmlFor="nombre">Descripción</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default DetallesProducto;